function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "phone-icon",
  d: "M15.226 19.932c-2.614-.802-4.92-2.206-6.936-4.223s-3.42-4.323-4.222-6.936a1.54 1.54 0 0 1 .383-1.541l1.929-1.93a1.032 1.032 0 0 1 1.46 0L8.896 6.36c.498.64.448 1.639.07 2.356-1.083 2.059-.824 3.905.778 5.54 1.605 1.637 3.45 1.9 5.534.787.72-.384 1.722-.435 2.366.066l.96.96a1.039 1.039 0 0 1 .091 1.552l-1.928 1.929a1.54 1.54 0 0 1-1.541.383z"
});

var SvgPhone = function SvgPhone(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgPhone;